/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import * as config from "../../config"

const SEO = ({ description, meta, title }) => {
  const { site, datoCmsFaviconMetaTags, datoCmsSite } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            description
            social {
              twitter
            }
          }
        }
        datoCmsFaviconMetaTags {
          tags
          id
        }
        datoCmsSite {
          id
          globalSeo {
            fallbackSeo {
              description
              title
              image {
                url
              }
            }
            siteName
            facebookPageUrl
            siteName
            titleSuffix
            twitterAccount
          }
        }
      }
    `
  )
  const defaultTitle = config.site_name
  const metaDescription =
    description || datoCmsSite.globalSeo?.fallbackSeo?.description
  const globalMetaTags = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `og:title`,
      content: datoCmsSite?.globalSeo?.titleSuffix
        ? title + datoCmsSite?.globalSeo?.titleSuffix
        : title,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `og:image`,
      content: datoCmsSite?.globalSeo?.fallbackSeo?.image?.url,
    },
    {
      name: `twitter:card`,
      content: datoCmsSite?.globalSeo?.twitterCard
        ? datoCmsSite?.globalSeo?.twitterCard
        : `summary`,
    },
    {
      name: `twitter:site`,
      content:
        site.siteMetadata?.social?.twitter ||
        datoCmsSite?.globalSeo?.twitterAccount ||
        "",
    },
    {
      name: `twitter:title`,
      content: title || datoCmsSite?.globalSeo?.siteName,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
  ]

  return (
    <Helmet
      htmlAttributes={{
        lang: config.locale,
      }}
      title={
        title ||
        datoCmsSite?.globalSeo?.siteName ||
        datoCmsSite?.globalSeo?.fallbackSeo?.title
      }
      defaultTitle={config.website_name}
      titleTemplate={defaultTitle ? `%s | ${config.website_name}` : null}
      meta={meta || globalMetaTags}
    >
      {datoCmsFaviconMetaTags &&
        datoCmsFaviconMetaTags.tags &&
        datoCmsFaviconMetaTags.tags.map((tags, index) => {
          return tags.tagName === "link" ? (
            <link
              key={index}
              rel={tags.attributes.rel || ""}
              sizes={tags.attributes.sizes || ""}
              type={tags.attributes.type || ""}
              href={tags.attributes.href || ""}
            />
          ) : (
            <meta
              key={index}
              name={tags.attributes.name || ""}
              content={tags.attributes.content || ""}
            />
          )
        })}
      {!meta || meta.length === 0
        ? globalMetaTags.map((tags, index) => {
            // Website Global Seo MetaTags
            return (
              <meta
                key={index}
                name={tags.name || ""}
                content={tags.content || ""}
              ></meta>
            )
          })
        : meta &&
          meta.length > 0 &&
          meta.map((seoMeta, index) => {
            // Content Page Seo MetaTags
            return !seoMeta.tagName || seoMeta?.tagName === "meta" ? (
              <meta
                key={index}
                name={seoMeta.attributes?.name || seoMeta.attributes?.property}
                content={seoMeta.attributes?.content || seoMeta?.content}
                data-react-helmet="true"
              ></meta>
            ) : (
              <link key={index} content={seoMeta?.content}></link>
            )
          })}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string, //PropTypes.string.isRequired
}

export default SEO
